import type { ReactNode } from 'react';
import type { BuilderStep } from '../../lib/types.js';
import type { PickerVariable, StepPath } from './definitionEdit.js';
import { Sentence } from './StepSentence.js';
import type { StepListContext } from './stepTypes.js';
const Node = ({ label, diamond }: { label: string; diamond?: boolean }) =>
  diamond ? (
    <span className="flex h-6 w-6 flex-none rotate-45 items-center justify-center rounded border border-warning bg-surface-elevated text-xs text-warning">
      <span className="-rotate-45">✋</span>
    </span>
  ) : (
    <span className="flex h-6 w-6 flex-none items-center justify-center rounded-full border border-outline-strong bg-surface-elevated text-[0.68rem] font-semibold text-ink-muted">
      {label}
    </span>
  );

export const StepRow = ({
  step,
  path,
  ctx,
  index,
  isLast,
  drawerOpen,
  vars,
  children,
}: {
  step: BuilderStep;
  path: StepPath;
  ctx: StepListContext;
  index: number;
  isLast: boolean;
  drawerOpen: boolean;
  vars: PickerVariable[];
  children: ReactNode;
}) => (
  <div className="group flex min-w-0 gap-3">
    <div className="flex flex-col items-center pt-1.5">
      <Node label={String(index + 1)} diamond={step.type === 'approval'} />
      {!isLast && <span className="w-px flex-1 bg-outline" />}
    </div>
    <div className="min-w-0 flex-1">
      <div>
        <div className="flex min-w-0 items-start gap-1.5">
          {/* Sentence, drawer, AND fork arms share one column so every
                    border lines up — nothing pokes past the sentence's edge. */}
          <div className="min-w-0 flex-1">
            <button
              type="button"
              onClick={() => ctx.onToggle(path.join('.'))}
              className={`flex w-full min-w-0 flex-wrap items-center gap-1.5 rounded-lg border bg-surface px-3 py-2 text-left text-sm transition-colors ${
                drawerOpen
                  ? 'rounded-b-none border-outline-strong bg-surface-elevated'
                  : 'border-outline hover:border-outline-strong'
              }`}
            >
              <Sentence step={step} vars={vars} destinations={ctx.destinationOptions} />
            </button>
            {children}
          </div>
          <div className="flex flex-none gap-1 pt-1.5 opacity-0 transition-opacity focus-within:opacity-100 group-hover:opacity-100">
            <button
              type="button"
              aria-label="Move step up"
              className="text-xs text-ink-subtle hover:text-ink"
              onClick={() => ctx.onMove(path, -1)}
            >
              ↑
            </button>
            <button
              type="button"
              aria-label="Move step down"
              className="text-xs text-ink-subtle hover:text-ink"
              onClick={() => ctx.onMove(path, 1)}
            >
              ↓
            </button>
            <button
              type="button"
              aria-label="Delete step"
              className="text-xs text-ink-subtle hover:text-danger"
              onClick={() => ctx.onRemove(path)}
            >
              ✕
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);
